export default __webpack_public_path__ + "static/media/kosova.324029de.png";